import {ShippingProviderConfiguration} from '../models/shipping/shippingProviderConfiguration.model';
import {ShippingOrder} from '../models/shipping/shippingOrder.model';

export namespace Shipping {
  export class GetProviders {
    static readonly type = '[Shipping api] Get Providers';

    constructor(public force: boolean = false) {
    }
  }

  export class GetProvider {
    static readonly type = '[Shipping api] Get Provider';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateProvider {
    static readonly type = '[Shipping api] Create Provider';

    constructor(public provider: ShippingProviderConfiguration) {
    }
  }

  export class UpdateProvider {
    static readonly type = '[Shipping api] Update Provider';

    constructor(public provider: ShippingProviderConfiguration) {
    }
  }

  export class DeleteProvider {
    static readonly type = '[Shipping api] Delete Provider';

    constructor(public provider: ShippingProviderConfiguration) {
    }
  }

  export class GetShippingProviders {
    static readonly type = '[Shipping api] Get Shipping Providers';

    constructor(public force: boolean = false) {
    }
  }

  export class GetShippingOrder {
    static readonly type = '[Shipping api] Get Shipping Order';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class GetShippingOrders {
    static readonly type = '[Shipping api] Get Shipping Orders';

    constructor(public force: boolean = false) {
    }
  }

  export class UpdateShippingOrderLocal {
    static readonly type = '[Shipping api] Update Shipping Order Local';

    constructor(public shippingOrder: ShippingOrder) {
    }
  }

  export class UpdateShippingOrderApi {
    static readonly type = '[Shipping api] Update Shipping Order Api';

    constructor(public id: string, public shippingOrder: ShippingOrder) {
    }
  }

  export class RequestShippingOrder {
    static readonly type = '[Shipping api] Request Shipping Order';

    constructor(public id: string, public force: boolean = false) {
    }
  }
}

